module.exports = __webpack_public_path__ + "img/Y.6d2f84f9.png";